import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import type { CalloutModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-banner-callout',
  templateUrl: './banner-callout.component.html',
  styleUrls: ['./banner-callout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerCalloutComponent {
  @Input() callout: CalloutModel
}
